import { React, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import cityLogo from "../Images/logo.webp";

function ContentPopup() {
  const [show, setShow] = useState(true);

  const handleModal = (e) => {
    setShow(!show);
  };

  return (
    <div>
      <div>
        <Modal
          show={show}
          onHide={handleModal}
          id="modelContent"
          size="xl"
          backdrop="static"
          keyboard={false}
          centered
        >
          <Button id="pop-close1" onClick={handleModal}>
            &times;
          </Button>
          <Modal.Header id="header">
            <img id="popImg" src={cityLogo} alt="img-responsive" />
          </Modal.Header>
          <div className="model-body">
            <ul className="llist">
              <li key="1">
                If you selected a Physical Card please allow 7-10 business days
                to receive. If you selected a Virtual Card expect a link will be
                sent to your email within 3-5 days from{" "}
                <a href={"mailto:" + process.env.REACT_APP_DESC_EMAIL}>
                  {process.env.REACT_APP_DESC_EMAIL}
                </a>
                ,{" "}
                <a href={"mailto:" + process.env.REACT_APP_DESC_PREP}>
                  {process.env.REACT_APP_DESC_PREP}
                </a>{" "}
                or{" "}
                <a href={"mailto:" + process.env.REACT_APP_NO_REPLY}>
                  {process.env.REACT_APP_NO_REPLY}
                </a>
              </li>
              <li key="2">
                Please do not discard your certificate until you receive your
                reward card.
              </li>
              <li key="3">
                You will need to finalize your order by following the
                instructions in that email from <br />
                <a href="mailto:info@bca-rewards.com">info@bca-rewards.com</a>
              </li>
              <br />
              <p>
                <strong>
                  PLEASE NOTE: You only have 30 days to activate your card.
                  Check your inbox, junk and spam and contact our customer
                  service line if you haven't received the email within the
                  week.
                </strong>
              </p>
            </ul>
          </div>
        </Modal>
      </div>
    </div>
  );
}

export default ContentPopup;
